import { fromJson, toJson } from 'angular';

import { IEpticaExtractHistoryData } from '../../models/eptica-extract';

export const TYPE_BOUNCE: MailCommentType = 'BOUNCE';
export const TYPE_LINKED: MailCommentType = 'LINKED';
export const TYPE_EVICTED: MailCommentType = 'EVICTED';
export const TYPE_FORWARD_TO_SKILL: MailCommentType = 'FORWARD_TO_SKILL';
export const TYPE_FORWARD_TO_TEAM: MailCommentType = 'FORWARD_TO_TEAM';
// Legacy forward types that used a different syntax
export const TYPE_FORWARD_BY_SKILL: MailCommentType = 'FORWARD_BY_SKILL';
export const TYPE_FORWARD_BY_TEAM: MailCommentType = 'FORWARD_BY_TEAM';

export type MailCommentType =
  | 'BOUNCE'
  | 'LINKED'
  | 'EVICTED'
  | 'FORWARD_TO_SKILL'
  | 'FORWARD_TO_TEAM'
  | 'FORWARD_BY_SKILL'
  | 'FORWARD_BY_TEAM';
export interface IMailComment {
  type: MailCommentType;
  date: Date;
  agent?: string;
  comment?: string;
  /**
   * @deprecated
   */
  skill?: IEpticaExtractHistoryData;
  data?: IEpticaExtractHistoryData;
  extraData: { [id: string]: string };
}

export class MailComment {
  static toComment(type: MailCommentType, date: Date, comment?: string): IMailComment {
    let data: IMailComment = {
      type: type,
      date: date,
      extraData: {},
    };
    if (comment) data.comment = comment;
    return data;
  }

  static serialize(data: IMailComment): string {
    if (data.agent) data.agent = encodeURI(data.agent);
    if (data.comment) data.comment = encodeURI(data.comment);
    return toJson(data);
  }

  static deserialize(serialized: string): IMailComment {
    let data: IMailComment = fromJson(serialized);
    if (data.agent) data.agent = decodeURI(data.agent);
    if (data.comment) data.comment = decodeURI(data.comment);
    return data;
  }

  // helper methods to mask the use of "legacy" syntax of types
  static isForwardToTeamType(type?: MailCommentType): boolean {
    return type === TYPE_FORWARD_TO_TEAM || type === TYPE_FORWARD_BY_TEAM;
  }

  static isForwardToSkillType(type?: MailCommentType): boolean {
    return type === TYPE_FORWARD_TO_SKILL || type === TYPE_FORWARD_BY_SKILL;
  }

  static isForwardType(type?: MailCommentType): boolean {
    return MailComment.isForwardToTeamType(type) || MailComment.isForwardToSkillType(type);
  }
}
